import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { BarChart3, User, Settings, Mic, Upload, LogOut, Menu, X, Shield } from 'lucide-react';

function Navbar() {
  const { currentUser, userProfile, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      setMenuOpen(false);
      setMobileMenuOpen(false);
    } catch (error) {
      console.error("Failed to log out", error);
    }
  };

  const isCreator = userProfile?.isCreator === true;
  const isAdmin = userProfile?.isAdmin === true;

  return (
    <nav className="fc-nav">
      <div className="fc-nav-inner">
        {/* Brand */}
        <a href="/" className="fc-brand">
          <span className="fc-brand-mark" aria-hidden="true"></span>
          <span className="fc-brand-name">Faircast</span>
        </a>

        {/* Desktop links */}
        <div className="fc-nav-links">
          <a href="/" className="fc-nav-link">Hjem</a>
          <a href="/about" className="fc-nav-link">Om os</a>
          <a href="/for-creators" className="fc-nav-link">For skabere</a>
          {currentUser && (
            <a href="/dashboard" className="fc-nav-link">
              <BarChart3 className="fc-nav-icon" />
              Du lytter til
            </a>
          )}
        </div>

        {/* Desktop right side */}
        <div className="fc-nav-actions">
          {!currentUser ? (
            <a href="/login" className="fc-btn-primary">
              Log ind / Tilmeld
            </a>
          ) : (
            <>
              {isCreator && (
                <a href="/creator-dashboard" className="fc-btn-creator">
                  <Mic size={14} />
                  Skaber Dashboard
                </a>
              )}
              {isAdmin && (
                <a href="/admin/dashboard" className="fc-btn-admin">
                  <Shield size={14} />
                  Admin
                </a>
              )}

              {/* User dropdown */}
              <div className="fc-dropdown-wrap">
                <button
                  onClick={() => setMenuOpen(!menuOpen)}
                  className="fc-user-btn"
                >
                  <User size={14} />
                  <span>{userProfile?.username || currentUser.email?.split('@')[0] || 'Bruger'}</span>
                  {isAdmin && <span className="fc-role-badge fc-role-admin">🛡️</span>}
                  {isCreator && <span className="fc-role-badge fc-role-creator">🎙️</span>}
                </button>

                {menuOpen && (
                  <div className="fc-dropdown" onClick={() => setMenuOpen(false)}>
                    <a href="/profile" className="fc-dropdown-item">
                      <User size={14} /> Profil
                    </a>
                    <a href="/settings" className="fc-dropdown-item">
                      <Settings size={14} /> Indstillinger
                    </a>
                    {isAdmin && (
                      <>
                        <div className="fc-dropdown-divider" />
                        <a href="/admin/dashboard" className="fc-dropdown-item fc-dropdown-item--danger">
                          <Shield size={14} /> Admin Panel
                        </a>
                      </>
                    )}
                    {isCreator && (
                      <>
                        <div className="fc-dropdown-divider" />
                        <a href="/creator-dashboard" className="fc-dropdown-item fc-dropdown-item--creator">
                          <Mic size={14} /> Skaber Dashboard
                        </a>
                        <a href="/podcast/import" className="fc-dropdown-item fc-dropdown-item--creator">
                          <Upload size={14} /> Importer Podcast
                        </a>
                      </>
                    )}
                    <div className="fc-dropdown-divider" />
                    <button onClick={handleLogout} className="fc-dropdown-item fc-dropdown-item--danger fc-dropdown-btn">
                      <LogOut size={14} /> Log ud
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          className="fc-hamburger"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Åbn menu"
        >
          {mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="fc-mobile-menu">
          <a href="/" className="fc-mobile-link" onClick={() => setMobileMenuOpen(false)}>Hjem</a>
          <a href="/about" className="fc-mobile-link" onClick={() => setMobileMenuOpen(false)}>Om os</a>
          <a href="/for-creators" className="fc-mobile-link" onClick={() => setMobileMenuOpen(false)}>For skabere</a>

          {currentUser && (
            <a href="/dashboard" className="fc-mobile-link" onClick={() => setMobileMenuOpen(false)}>
              Du lytter til
            </a>
          )}

          {!currentUser ? (
            <a href="/login" className="fc-mobile-cta" onClick={() => setMobileMenuOpen(false)}>
              Log ind / Tilmeld
            </a>
          ) : (
            <div className="fc-mobile-auth">
              <div className="fc-mobile-user">
                {userProfile?.username || currentUser.email?.split('@')[0] || 'Bruger'}
                {isAdmin && <span className="fc-role-badge fc-role-admin">🛡️</span>}
                {isCreator && <span className="fc-role-badge fc-role-creator">🎙️</span>}
              </div>

              {isAdmin && (
                <a href="/admin/dashboard" className="fc-mobile-link fc-mobile-link--danger" onClick={() => setMobileMenuOpen(false)}>
                  <Shield size={14} /> Admin Panel
                </a>
              )}
              {isCreator && (
                <>
                  <a href="/creator-dashboard" className="fc-mobile-link fc-mobile-link--creator" onClick={() => setMobileMenuOpen(false)}>
                    <Mic size={14} /> Skaber Dashboard
                  </a>
                  <a href="/podcast/import" className="fc-mobile-link fc-mobile-link--creator" onClick={() => setMobileMenuOpen(false)}>
                    <Upload size={14} /> Importer Podcast
                  </a>
                </>
              )}
              <a href="/profile" className="fc-mobile-link" onClick={() => setMobileMenuOpen(false)}>
                <User size={14} /> Profil
              </a>
              <a href="/settings" className="fc-mobile-link" onClick={() => setMobileMenuOpen(false)}>
                <Settings size={14} /> Indstillinger
              </a>
              <button onClick={handleLogout} className="fc-mobile-link fc-mobile-link--danger fc-mobile-btn">
                <LogOut size={14} /> Log ud
              </button>
            </div>
          )}
        </div>
      )}
    </nav>
  );
}

export default Navbar;
